export default "__VITE_ASSET__CNkY2aJ8__"